export default {"src":"https://cdn.tanzhi.cn/_next/static/media/unknown.a39b1327.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};